import { z } from 'zod';
import { email, tenDigitPhone } from './institute.schema';

/**
 * Another administrator for an institute.
 *
 * Mirrors `addInstituteAdminSchema` in the backend's institutes.validation.ts,
 * and reuses the create form's own email and phone rules so the first
 * administrator and every later one are held to the same standard.
 */
export const addAdminSchema = z.object({
  firstName: z.string().trim().min(1, 'Enter their first name').max(60, 'That name is too long'),
  lastName: z.string().trim().min(1, 'Enter their last name').max(60, 'That name is too long'),
  email,
  phone: tenDigitPhone,
});

export type AddAdminFormValues = z.input<typeof addAdminSchema>;
export type AddAdminPayload = z.output<typeof addAdminSchema>;

export const EMPTY_ADD_ADMIN_FORM: AddAdminFormValues = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
};
